import { defineStore } from 'pinia'
import { nextTick } from 'vue'

export const useOnboardingStore = defineStore('onboarding', {
  state: () => ({
    typeClient: null,
    steps: {
      step1: null,
      step2: null,
      step3: null
    },
    token: null,
    documentId: null,
    clientId: null,
    clientName: null,
    foreignCounterpartyName: null,
    foreignCounterpartyCountry: null
  }),

  getters: {
    getStepData: (state) => (step) => state.steps[`step${step}`],
    isStepCompleted: (state) => (step) => !!state.steps[`step${step}`],
    pfForm: (state) => state.steps.step1 || {},
    pjForm: (state) => state.steps.step1 || {},
    getToken: (state) => state.token
  },

  actions: {
    setTypeClient(type) {
      this.typeClient = type
    },
    setStepData(step, data) {
      this.steps[`step${step}`] = data
    },
    resetState(keepType = false, newType = null, subscriptionCode = null) {
      this.$reset()

      if (keepType && newType) {
        nextTick(() => {
          this.setTypeClient(newType)
        })
      }

      if (keepType && subscriptionCode) {
        nextTick(() => {
          this.steps.step2 = { subscriptionCode }
        })
      }
    },
    setToken(token) {
      this.token = token
    },
    setPFForm(data) {
      if (data.pf != null) {
        this.steps.step1 = {
          cityOfBirth: data.pf.cityOfBirth || '',
          stateOfBirth: data.pf.stateOfBirth || '',
          profession: data.pf.profession || '',
          pfCompanyName: data.pf.pfCompanyName || '',
          averageMonthlyIncome: Number(data.pf.averageMonthlyIncome).toFixed(2) || '',
          totalAssets: Number(data.pf.totalAssets).toFixed(2) || '',
          isPep: data.pf.isPep === true ? true : false,
          pepName: data.pf.pepName || '',
          pepCpf: data.pf.pepCpf || '',
          hasOtherCitizenship: data.pf.otherCitizenship?.trim() ? true : null,
          otherCitizenship: data.pf.otherCitizenship?.trim() || null,
          documentId: data.documentId || null
        }

        this.steps.step2 = {
          banks: data.banks || [],
          isAnnualMoreThan50: data.pf.annualTargetVolume
            ? Number(data.pf.annualTargetVolume) > 50000
            : null,
          annualTargetVolume: Number(data.pf.annualTargetVolume).toFixed(2),
          isEuaResidentialTaxCitizen: data.pf.isEuaResidentialTaxCitizen,
          foreignCounterpartyName: data.pf.foreignCounterpartyName?.trim(),
          foreignCounterpartyCountry: data.pf.foreignCounterpartyCountry?.trim()
        }
      }

      this.steps.step3 = {
        documents: data.documents || []
      }
    },
    setPJForm(data) {
      this.steps.step1 = {
        businessPartners: data.pj.businessPartners || [],
        capitalSocial: Number(data.pj.capitalSocial).toFixed(2)
      }
      this.steps.step2 = {
        banks: data.banks || []
      }
      this.steps.step3 = {
        documents: data.documents || []
      }
    }
  },

  persist: true
})
